import { render, staticRenderFns } from "./jianyandan_count.vue?vue&type=template&id=b8d0cef2&scoped=true&"
import script from "./jianyandan_count.vue?vue&type=script&lang=js&"
export * from "./jianyandan_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d0cef2",
  null
  
)

export default component.exports